import SvgIcon from "./SvgIcon";

export default function TennisIcon({
  width = "24",
  height = "24",
  color = "#000"
}) {
  return (
    <SvgIcon width={width} height={height}>
      <path
        d="M5 0a3 3 0 100 6 3 3 0 000-6zM4 3a1 1 0 112 0 1 1 0 01-2 0zM10.746 3.154l.084-.083.097-.098.002.002c3.393-3.257 8.152-4.12 11.184-1.088s2.169 7.792-1.088 11.184l.002.002a14.638 14.638 0 01-.18.181c-.43.43-.884.821-1.355 1.17a10.149 10.149 0 01-2.25 1.31c-1.092.454-2.112.632-3.03.793l-.184.032c-.978.172-1.878.349-2.877.804-.988.45-2.12 1.198-3.487 2.559l-2.713 2.713a2 2 0 01-2.828 0l-.757-.758a2 2 0 010-2.828l2.719-2.72c1.357-1.363 2.102-2.493 2.552-3.48.455-.999.632-1.899.804-2.877l.032-.183c.161-.919.34-1.938.794-3.031a10.15 10.15 0 011.31-2.25c.348-.47.74-.924 1.169-1.354zm1.499 1.33c-.654.666-1.134 1.27-1.494 1.831-1.6 2.54-1.463 5.187.143 6.792 1.605 1.605 4.252 1.742 6.791.142.56-.36 1.166-.84 1.831-1.494C22.43 8.78 22.66 5.263 20.7 3.301c-1.962-1.961-5.479-1.73-8.454 1.183zM8.457 13.68a11.768 11.768 0 01-1.317 2.19l.992.991a11.767 11.767 0 012.468-1.439c-.394-.249-.769-.548-1.12-.9s-.652-.727-.901-1.12c-.039.092-.08.184-.122.278zM2.78 20.463l.757.757 3.064-3.063-.758-.757z"
        fill={color}
      />
    </SvgIcon>
  )
}
